import React from 'react';

const DetailField = ({ label, children }) => (
   <div>
      <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">
         {label}
      </p>
      <div className="text-sm text-gray-900 dark:text-gray-100 whitespace-pre-wrap break-words">
         {children}
      </div>
   </div>
);

export default DetailField;
